import APIClient from '@/shared/http/clients/api'

const resourceName = 'despesaitem'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (expenseID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/despesa/${expenseID}`, data, config)
const GetEnum = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetEnum`, data, config)
const GetDepesasItem = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetDepesasItem`, data, config)
const GetAllPaging = (expenseID, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/despesa/${expenseID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const GetAttached = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/anexo/${id}`, config)
const SetApproved = (data, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/approved`, data, config)
const SetDisapproved = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/disapproved`, data, config)
const Create = (formData, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/upload`, formData, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const ReprovaDespesa = (despesaid, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/ReprovaDespesa/${despesaid}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const SetIncluida = (config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SetIncluida`, config)
const SetNewItem = (despesaId, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SetNewItem/${despesaId}`, config)
const DeleteDespesaItem = (despesaId, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/DeleteDespesaItem/${despesaId}`, config)
const GetDespesaItemFly = (despesaItemId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetDespesaItemFly/${despesaItemId}`, data, config)

const ExpenseItemRepository = {
  GetAll,
  ReprovaDespesa,
  GetAllPaging,
  GetById,
  GetAttached,
  SetApproved,
  SetDisapproved,
  Create,
  Update,
  Delete,
  GetDepesasItem,
  GetEnum,
  SetIncluida,
  SetNewItem,
  DeleteDespesaItem,
  GetDespesaItemFly
}

export default ExpenseItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/expenseitem.js